import Seo from "../Seo/Seo";
import BgSlider from "../Hero/bg";
import MissionCard from "../Mission/MissionCard";
import AboutCenter from "../About/AboutCenter";

export default function Mission() {
    return <>
        <Seo
            title="Nos Missions | Provence Paie - Solutions paie et conformité sociale"
            description="Explorez les services paie de Provence Paie : gestion sociale, conseil URSSAF, externalisation RH et sécurité juridique pour cabinets d'expertise comptable."
            pathname="/Mission"
        />
        <BgSlider
            title="Nos Missions"
            subtitle=""
        />
        <AboutCenter
            Title={<>
                Nos Services:<br /> <h3>Un Accompagnement à 360°</h3>
            </>}
            Subtitle="Simplifiez vos missions sociales avec un partenaire de confiance, né de l’expertise comptable."


        >

            <p>
                Situé à <strong>Cavaillon,</strong> au cœur de la Provence, PROVENCE PAIE est un cabinet de gestion sociale
                exclusivement dédié à l’accompagnement des cabinets d’expertise comptable. Nous ne sommes pas
                seulement un prestataire ; nous sommes le prolongement de votre pôle social.
            </p>
        </AboutCenter>
        <MissionCard/>
    </>

}